<template>
  <v-card-text class="flex-shrink-1 overflow-y-auto pl-0">
    <p v-translate>
      You blocked this user. This person no longer be able to send you messages
    </p>

    <v-row>
      <v-col cols="4">
        <v-btn
          color="primary"
          rounded
          class="text-none btn btn-register subtitle-2 d-block"
          @click="unblock()"
        >
          <strong><translate>Unblock</translate></strong>
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</template>
<script>
import ChatService from "@/services/ChatService";
export default {
  props: {
    friend: {type: Object,default: () => {}},
  },
  data() {
    return {}
  },
  computed: {
  },
  methods: {
    async unblock() {
      let result = await ChatService.unblockFriend(this.friend.user.id);
      if (!result.error) {
        this.$store.commit('chat/commitFriend', result.myFriend)
        this.$store.state.toggle.ChatFixedBottom.sendData({
          type: 'commitFriend',
          payload: result.theirFriend
        }, this.friend.user.id)
      }
    }
  },
};
</script>